import React from "react";
import { Pagination } from "antd";

export const PaginationAdjustComponentBenchmarking = ({
  pagination,
  setPagination,
  sizeChanger = true,
}) => {
  const onShowSizeChange = (current, pageSize) => {
    setPagination({
      ...pagination,
      rowsPerPage: pageSize,
    });
  };
  const onChange = (pageNumber) => {
    setPagination({
      ...pagination,
      page: pageNumber,
    });
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px",
      }}
    >
      <Pagination
        showSizeChanger={sizeChanger}
        onShowSizeChange={onShowSizeChange}
        onChange={onChange}
        current={pagination.page}
        total={pagination.totalRows}
        pageSize={pagination.rowsPerPage}
      />
    </div>
  );
};

export const PaginationAdjustComponent = ({
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  total,
}) => {
  const onShowSizeChange = (current, pageSize) => {
    setRowsPerPage(pageSize);
  };
  const onChange = (pageNumber) => {
    setPage(pageNumber);
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px",
      }}
    >
      <Pagination
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={onChange}
        current={page}
        total={total}
        pageSize={rowsPerPage}
      />
    </div>
  );
};

export const PaginationComponent = ({ page, setPage, total, pageSize }) => {
  const onChange = (pageNumber) => {
    setPage(pageNumber);
  };
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginTop: "20px",
      }}
    >
      <Pagination
        current={page}
        onChange={onChange}
        total={total}
        showSizeChanger={false}
        defaultPageSize={pageSize}
      />
    </div>
  );
};
